import { formatEarningsPercentage } from '../helpers'
import { earningsWarningScenarios, marginCostLabels, marginCostTypes, maxTopMarginCosts } from './constants'

export const getEarningsPercentageColor = (percentage, theme) => {
  if (percentage === null) return theme.colors.text.default
  if (Number(percentage) < 0) return theme.colors.danger.default

  return theme.colors.success.default
}

export const getEarningsWarningScenario = earnings => {
  if (earnings.has_missing_cogs && earnings.has_missing_logistics_or_customs) {
    return earningsWarningScenarios.missingAllCosts
  }

  if (earnings.has_missing_logistics_or_customs) return earningsWarningScenarios.missingLogisticsOrCustoms
  if (earnings.has_missing_cogs) return earningsWarningScenarios.missingCogs

  return null
}

export const getTopMarginCosts = earnings => {
  if (earnings.has_missing_logistics_or_customs) return []

  const marginCosts = [
    { type: marginCostTypes.refunds, percentage: earnings.refunds_percentage },
    { type: marginCostTypes.logistics, percentage: earnings.logistics_percentage },
    { type: marginCostTypes.customs, percentage: earnings.customs_percentage },
  ]

  return marginCosts
    .filter(marginCost => Number(marginCost.percentage) > 0)
    .sort((first, second) => Number(second.percentage) - Number(first.percentage))
    .slice(0, maxTopMarginCosts)
}

export const getMarginInsightValues = (marginCosts, t, language) => {
  return marginCosts.reduce((values, marginCost, index) => {
    return {
      ...values,
      [`cost${index + 1}`]: t(marginCostLabels[marginCost.type]),
      [`percentage${index + 1}`]: formatEarningsPercentage(marginCost.percentage, language),
    }
  }, {})
}
